

import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  fetchPermissions,
  fetchRoleById,
  fetchRoles,
} from "../../features/admin/RoleSlice";
import TableComponent from "../../components/TableComponent";
import { PencilSquareIcon, TrashIcon } from "@heroicons/react/24/outline";
import { deleteRole } from "../../features/admin/RoleSlice";
import { toast } from "react-toastify";
import RoleModal from "../../components/admin/RoleModal";
import ConfirmDeleteModal from "../../components/ConfirmDeleteModal";
import AuditHistoryButton, {
  canViewAuditHistory,
} from "../../components/admin/AuditHistoryButton";

const getUserPermissions = () => {
  const permissions = localStorage.getItem("permissions");
  return permissions
    ? JSON.parse(permissions).map((p) => p.permissionSlug)
    : [];
};

const userId = localStorage.getItem("userId");
const hasPermission = (requiredPermission) => {
  if (userId == 1) {
    return true;
  }
  const userPermissions = getUserPermissions();
  return userPermissions.includes(requiredPermission);
};

const Roles = () => {
  const dispatch = useDispatch();
  const { roles, status, error } = useSelector((state) => state.roles);
  const permissions = useSelector((state) => state.roles?.permissions);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [currentUser, setCurrentUser] = useState(null);
  const [deleteId, setDeleteId] = useState(null);
  const [isDeleteOpen, setIsDeleteOpen] = useState(false);
  const handleOpenDeleteModal = (id) => {
    setDeleteId(id);
    setIsDeleteOpen(true);
  };

  const handleCloseDeleteModal = () => {
    setDeleteId(null);
    setIsDeleteOpen(false);
  };
  const handleOpenModal = (user = null) => {
    if (user?.id) {
      dispatch(fetchRoleById(user.id)).then((res) => {
        if (res.meta.requestStatus === "fulfilled") {
          setCurrentUser(res.payload);
          setIsModalOpen(true);
        } else {
          toast.error("Không thể lấy dữ liệu chức vụ!");
        }
      });
    } else {
      setCurrentUser(null);
      setIsModalOpen(true);
    }
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };
  const handleDelete = (id) => {
    let data = { ids: [deleteId] };
    dispatch(deleteRole(data)).then((res) => {
      if (res.meta.requestStatus === "fulfilled") {
        handleCloseDeleteModal();

        toast.success("Xóa chức vụ thành công!");
      } else {
        toast.error("Đã xảy ra lỗi khi xóa chức vụ!");
      }
    });
  };
  useEffect(() => {
    window.scrollTo(0, 0);
    dispatch(fetchPermissions());
    dispatch(fetchRoles());
  }, []);
  useEffect(() => {
    if (status === "idle") {
      dispatch(fetchRoles());
      dispatch(fetchPermissions());
    }
  }, [status, dispatch, permissions]);
  if (status === "loading") {
    return <p>Loading...</p>;
  }

  if (status === "failed") {
    return <p>Error: {error}</p>;
  }
  const headers = [{ key: "roleName", label: "Tên chức vụ" }];
  if (
    hasPermission("ROLE_UPDATE") ||
    hasPermission("ROLE_DESTROY") ||
    canViewAuditHistory()
  ) {
    headers.push({ key: "setting", label: "Phương thức" });
  }
  const tableSettings = {
    renderSettings: (item) => (
      <div className="flex space-x-2">
        {hasPermission("ROLE_UPDATE") && (
          <button
            onClick={() => handleOpenModal(item)}
            className="btn btn-outline btn-warning btn-sm px-3 my-1 rounded "
          >
            <PencilSquareIcon className="w-5 h-5" />
          </button>
        )}
        {hasPermission("ROLE_DESTROY") && (
          <button
            // onClick={() => handleDelete(item.id)}
            onClick={() => handleOpenDeleteModal(item.id)}
            className=" btn btn-outline btn-error btn-sm px-3 my-1 rounded"
          >
            <TrashIcon className="w-5 h-5" />
          </button>
        )}
        <AuditHistoryButton module="ROLE" entityType="Role" entityId={item.id} />
      </div>
    ),
  };
  return (
    <div className="p-6">
      <h1 className="text-2xl font-semibold mb-4">Quản lý chức vụ</h1>

      {hasPermission("ROLE_CREATE") ? (
        <button
          onClick={() => handleOpenModal()}
          className="btn btn-success transition-colors px-4 py-2 rounded mb-4"
        >
          + Thêm chức vụ
        </button>
      ) : (
        <div></div>
      )}
      <TableComponent headers={headers} data={roles} settings={tableSettings} />
      {isModalOpen && (
        <RoleModal
          role={currentUser}
          onClose={handleCloseModal}
          isOpen={isModalOpen}
        />
      )}
      <ConfirmDeleteModal
        isOpen={isDeleteOpen}
        onClose={handleCloseDeleteModal}
        onConfirm={handleDelete}
      />
    </div>
  );
};

export default Roles;



